import styled from 'styled-components';

export default styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.blueLightest} 0%,
    ${({ theme }) => theme.colors.grayPale} 100%
  );
  overflow: hidden;

  .content-wrapper {
    padding: 16px;
    max-width: 500px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    box-shadow: ${({ theme }) => theme.main.shadow};
    border: 1px solid rgba(255, 255, 255, 0.2);

    @media (max-width: 768px) {
      padding: 20px;
      margin: 20px;
      border-radius: 12px;
    }

    @media (max-width: 480px) {
      padding: 16px;
      margin: 16px;
      border-radius: 10px;
    }
  }

  .title {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 16px;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 2.2rem;
      margin-bottom: 14px;
    }

    @media (max-width: 480px) {
      font-size: 1.8rem;
      margin-bottom: 12px;
    }
  }

  .description {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grayPrimary};
    line-height: 1.6;
    margin-bottom: 32px;
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;

    @media (max-width: 768px) {
      font-size: 15px;
      margin-bottom: 28px;
      line-height: 1.5;
    }

    @media (max-width: 480px) {
      font-size: 14px;
      margin-bottom: 24px;
      line-height: 1.4;
    }
  }

  .card-container {
    border: 2px dashed ${({ theme }) => theme.colors.bluePrimary};
    background-color: ${({ theme }) => theme.colors.primaryHighlight};
    padding: 24px;
    width: 80%;
    border-radius: 12px;

    @media (max-width: 768px) {
      padding: 20px;
      border-radius: 10px;
    }

    @media (max-width: 480px) {
      padding: 16px;
      border-radius: 8px;
    }

    .card-content {
      background-color: ${({ theme }) => theme.colors.bluePrimary};
      padding: 16px;
      border-radius: 8px;
      color: ${({ theme }) => theme.colors.light};
      font-weight: 500;
      font-size: 16px;

      @media (max-width: 768px) {
        padding: 14px;
        font-size: 15px;
        border-radius: 6px;
      }

      @media (max-width: 480px) {
        padding: 12px;
        font-size: 14px;
        border-radius: 6px;
      }
    }
  }
`;

export const IconCircle = styled.div<{ $bgColor: string; $textColor: string }>`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.$bgColor};
  color: ${(props) => props.$textColor};
  box-shadow: ${({ theme }) => theme.main.shadow};
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
  }

  @media (max-width: 480px) {
    width: 60px;
    height: 60px;
  }
`;
